document.addEventListener('DOMContentLoaded', function () {
    const hamburgers = document.querySelectorAll('.hamburger')
    hamburgers.forEach(hamburger => {
        hamburger.addEventListener('click', e => {
            hamburger.classList.toggle('open')
        })
    })

    if (
        document.URL.includes('rapid.uk') ||
        document.URL.includes('rapid.abs') ||
        document.URL.includes('rapidgroup.apps.absolutemedia.co.uk')
    ) {
        document.querySelector('body').classList.add('rapid-site')
    }
    document.querySelectorAll('#hero-carousel').forEach(function(element) {
        new Splide(element, {
            heightRatio: 0.5,
            autoplay: true,
            height: '800px',
            type: 'loop',
            pagination: false,
            intersection: {
                inView: {
                    autoplay: true
                }
            },
            breakpoints: {
                991: {
                    height: 'calc(100vh - 80px)'
                },
                1024: {
                    height: '650px'
                },
                1440: {
                    height: '800px'
                }
            }
        }).mount();
    });
    document.querySelectorAll('#brand-cloud-slider').forEach(function(element) {
        if (element) {
            const mapEle = element;
            var startPosition = Number(mapEle.getAttribute('start-position')) - 1 || 0;

            new Splide(element, {
                type: 'loop',
                start: startPosition,
                perPage: 6,
                autoplay: true,
                breakpoints: {
                    768: {
                        perPage: 3,
                        pagination: false
                    },
                    1024: {
                        perPage: 3
                    },
                    1440: {
                        perPage: 5
                    }
                }
            }).mount();
        }
    });
    document.querySelectorAll('#testimonial-slider').forEach(function(element) {
        if (element) {
            new Splide(element, {
                type: 'loop',
                perPage: 1,
                autoplay: true,
                arrows: false,
                breakpoints: {
                    768: {
                        pagination: false
                    }
                }
            }).mount();
        }
    });
})
